import { Component, Event, EventEmitter, h, Host, Prop, State } from "@stencil/core";
import { ButtonSize, ButtonVariant } from "../../button/button.enum";

@Component({
    tag: "ux-chat-message-bar",
    styleUrl: "chat-message-bar.scss",
    shadow: true
})
export class ChatMessageBar {
    /** The placeholder text. */
    @Prop() readonly placeholder!: string;
    /** indicates if the message bar is disabled */
    @Prop() readonly disabled?: boolean;
    /** Fired when the message has been sent */
    @Event() uxMessageSend: EventEmitter<string>;

    @State() messageText = "";

    private handleInput(event: Event) {
        this.messageText = (event.target as HTMLInputElement).value;
    }

    private handleKeydown(event: KeyboardEvent) {
        if (event.ctrlKey && event.key === "Enter") {
            this.sendMessage();
        }
    }

    private sendMessage() {
        if (!this.disabled && this.messageText.trim()) {
            this.uxMessageSend.emit(this.messageText);
            this.messageText = "";
        }
    }

    render() {
        return (
            <Host>
                <div id="chat-message-bar">
                    <ux-input
                        id="chat-textarea"
                        name="chat-message"
                        placeholder={this.placeholder}
                        disabled={this.disabled ? false : undefined}
                        value={this.messageText}
                        onInput={(event) => this.handleInput(event)}
                        onKeyDown={(event) => this.handleKeydown(event)}
                    ></ux-input>
                    <ux-button
                        size={ButtonSize.Icon}
                        variant={ButtonVariant.Primary}
                        icon="paper-plane"
                        label="Send"
                        disabled={this.disabled}
                        onClick={() => this.sendMessage()}
                    />
                </div>
            </Host>
        );
    }
}
